import React from 'react';

/* MobX */
import { observer } from 'mobx-react-lite';

/* MUI */
import Typography from '@material-ui/core/Typography';
import { Grid, TextField, Button } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Checkbox from '@material-ui/core/Checkbox';

/* Langan Components */
import FormInputTextField from '../../form-input/form-input-textfield.component';
import AreaInfo from './area-info/area-info.component';
import EsriMap from "../../map/EsriMap";
import SketchWidget from "../../map/SketchWidget";
import FeatureLayer from "../../map/FeatureLayer";
import { FileUploadButton } from '../../form-input/form-file-upload-button.component';


const ExcludedAreaAppeal = observer((props) => {
  const { expanded,
    handleAccordianChange,
    statusReady, statusChange,
    statusExcluded,
    excluded,
    handleExcludedChange,
    handleExcludedAreaChange,
    setExcludedGraphics,
    excludedFileName,
    excludedFileChange,
    excludedWarning,
    area,
    mapBlock,
    assessorBlock
  } = props;

  const {
    F_Appealed_Excluded_Area,
    F_Appealed_Billable_Impermeable_Area,
    F_Appealed_Impermeable_Area,
    F_Applicant_Comments_Excluded
  } = excluded;

  return (
    <Accordion expanded={expanded === 'panel3'} onChange={handleAccordianChange('panel3')}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} id="inaccurateExcludedAreaAppeal" style={{ backgroundColor: "whitesmoke" }} >
        <Typography variant="h6" gutterBottom color="primary">
          <Checkbox
            checked={statusReady}
            disabled={statusChange}
            color="primary"
            inputProps={{ 'aria-label': 'secondary checkbox' }}
          />
          Enter Information for Inaccurate Excluded Parcel Level Area
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Typography variant="body1">
            In very rare cases, areas that do not drain to SFPUC sewers are not subject to the
            stormwater charge. This area is called excluded area. Area draining directly to San
            Francisco Bay, the Pacific Ocean, a lake, or a non-SFPUC owned sewer are the most
            common excluded areas. You must show proof, verified by the City of San Francisco,
            of your property's drainage.
          </Typography>
          <Grid item xs={12}>
            {statusChange &&
              <Typography variant="h6" color="error">
                There is a current appeal pending. Please contact us at (415)-551-3000 before submitting a new request.
              </Typography>}
            <Typography variant="body1">
              Sketch on the map below to show area changes or populate the area field in the form below.
            </Typography>

            <EsriMap screenSize="sketch" itemId={process.env.REACT_APP_WEBMAP_ID} type="static">
              {statusExcluded !== "submitted" &&
                <SketchWidget
                  handleAreaChange={handleExcludedAreaChange}
                  handleGraphicsChange={setExcludedGraphics}
                  parcelId={mapBlock}
                  excluded={true} />
              }
              <FeatureLayer parcelId={mapBlock} navigation={false} />
            </EsriMap>

          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">
              The total excluded area for which the Map Block Lot is being billed is incorrect.
            </Typography>
          </Grid>

          <AreaInfo
            mapBlock={mapBlock}
            assessorBlock={assessorBlock}
            area={area}
          />

          <FormInputTextField
            label="Appealed Excluded Area"
            required={true}
            name="F_Appealed_Excluded_Area"
            value={F_Appealed_Excluded_Area}
            onChange={handleExcludedChange}
            size={5}
            InputProps={{ readOnly: statusChange }}
          />

          <FormInputTextField
            label="Appealed Impermeable Area"
            required={true}
            name="F_Appealed_Impermeable_Area"
            value={F_Appealed_Impermeable_Area}
            onChange={handleExcludedChange}
            size={5}
            InputProps={{ readOnly: statusChange }}
          />

          <FormInputTextField
            label="Billable Appealed Impermeable Area"
            required={true}
            name="F_Appealed_Billable_Impermeable_Area"
            value={F_Appealed_Billable_Impermeable_Area}
            onChange={handleExcludedChange}
            size={5}
            InputProps={{ readOnly: statusChange }}
          />

          {excludedWarning &&
            <Grid item xs={12} align="left" >
              <Typography color="error">{excludedWarning}</Typography>
            </Grid>}
          <Grid item xs={12} align="left">
            <FileUploadButton
              description={"Attach Relevant Documentation To Support Appeal"}
              fileChange={excludedFileChange}
              disabled={statusChange} />
          </Grid>
          <Grid item xs={12} align="center">
            <TextField name="F_Applicant_Comments_Excluded" variant="outlined" label="Applicant Comments" fullWidth
              value={F_Applicant_Comments_Excluded} onChange={handleExcludedChange} InputProps={{ readOnly: statusChange }} />
          </Grid>
        </Grid>

      </AccordionDetails>
    </Accordion>

  )
})

export default ExcludedAreaAppeal;